import CusModalFooter from "./CusModalFooter";

export default CusModalFooter;